import { Typography } from '@breetometer/components';
import { BreadcrumbAngleIcon } from 'BreetAssets';
import { TableTooltip } from 'BreetComponents';

import type { IModalHeader } from '../helpers';

const ModalHeader = ({ handleBackLink, handleRootBackLink, title, root }: IModalHeader) => {
	const isRoot = title === root;
	const isHideBacklink = (isRoot || !root) && typeof handleRootBackLink !== 'function';
	const backlinkClass = `cursor_pointer right-sheet_navigator${isHideBacklink ? '_hide' : ''} svg-dark`;

	return (
		<div
			className='right-sheet_header bg-primary-500 border-bottom-dark-navy'
			data-testid='modal-header'
		>
			<BreadcrumbAngleIcon
				focusable
				aria-label='Go back'
				role='button'
				tabIndex={0}
				onClick={(isRoot || !root) && handleRootBackLink ? handleRootBackLink : handleBackLink}
				className={backlinkClass}
			/>

			<Typography
				as='h3'
				className='color-neutral-50 truncate'
			>
				<TableTooltip
					message={title}
					enabled={!!title}
					truncate
				>
					{title}
				</TableTooltip>
			</Typography>
		</div>
	);
};

export default ModalHeader;
